import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/var/www/web/layouts/default.vue").then(m => m.default || m))
}